import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { PaginationConfig } from '@shared';
import { PayoutActivationLists, PayoutActivationSummary, UserService } from '@shared/services';
import { firstValueFrom } from 'rxjs';
import { Pagination, PaginationService, UtilsService } from 'thkee-common';
import { NgTemplateOutlet, DatePipe } from '@angular/common';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { CommonPaginationComponent } from '../../../@shared/components/common-pagination/common-pagination.component';

const pageSize: number = 10;

interface QueryParams {
  page: number;
  page_size: number;
  search?: string;
  submited_date?: string;
  verified_date?: string;
}

@Component({
    selector: 'app-payout-activation',
    templateUrl: './payout-activation.component.html',
    styleUrls: ['./payout-activation.component.scss'],
    imports: [NgTemplateOutlet, AngularSvgIconModule, CommonPaginationComponent, RouterLink, DatePipe]
})
export class PayoutActivationComponent implements OnInit {
  private userService = inject(UserService);
  private paginationService = inject(PaginationService);
  private utilsService = inject(UtilsService);
  private activatedRoute = inject(ActivatedRoute);

  payoutActivationSummary!: PayoutActivationSummary;
  payoutActivation!: Pagination<PayoutActivationLists>;
  isLoading: boolean = false;
  isLoadingSummary: boolean = false;
  queryParams: QueryParams = { page: 1, page_size: pageSize };

  ngOnInit(): void {
    this.getPayoutActivationSummary();
    this.queryUpdater();
  }
  // Update query
  private queryUpdater() {
    firstValueFrom(this.activatedRoute.queryParams).then((params) => {
      this.queryParams.page = params['page'] ? +params['page'] : 1;
      this.queryParams.page_size = params['page_size'] ? +params['page_size'] : 10;
      this.getPayoutActivation(this.queryParams);
    });
  }

  private getPayoutActivationSummary() {
    this.isLoadingSummary = true;
    this.userService.getPayoutActivationSummary().subscribe({
      next: (res) => {
        this.isLoadingSummary = false;
        this.payoutActivationSummary = res;
      },
      error: (err) => {},
    });
  }

  private getPayoutActivation(queryParams = {} as object) {
    this.isLoading = true;
    this.userService.getPayoutActivation(queryParams).subscribe({
      next: (res) => {
        console.log('res', res);
        this.isLoading = false;
        this.payoutActivation = res;
        this.paginationService.getPager(res.count, this.queryParams.page, this.queryParams.page_size);
      },
      error: (err) => {
        this.isLoading = false;
      },
    });
  }

  // Color tag
  getStatusTagColor(status: string): string {
    if (this.utilsService.isStatus(status)) {
      return this.utilsService.getStatusColor(status);
    }
    return 'green';
  }

  search(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    this.queryParams.search = inputElement.value;
    this.getPayoutActivation(this.queryParams);
  }

  selectSubmitDate(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    this.queryParams.submited_date = inputElement.value;
  }

  selectVerifiedDate(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    this.queryParams.verified_date = inputElement.value;
    this.getPayoutActivation(this.queryParams);
  }

  // Pagination
  paginationConfig: PaginationConfig = {
    pageCountSummary: true,
    pageSize: true,
    firstAndLast: true,
  };
  paginationAction(page_number: number) {
    this.queryParams.page = page_number;
    this.getPayoutActivation(this.queryParams);
  }

  pageSizeAction(value: number) {
    this.queryParams.page_size = value;
    this.queryParams.page = 1;
    this.getPayoutActivation(this.queryParams);
  }

}
